import { ChangePasswordServiceProtoDefinition } from '@/compiled_proto/com/celertech/baseserver/api/user/ChangePasswordServiceProto';
import { LoginServiceDefinition } from '@/compiled_proto/com/celertech/baseserver/communication/login/LoginProto';
import { LogoutServiceDefinition } from '@/compiled_proto/com/celertech/baseserver/communication/login/LogoutProto';
import { ServerConfigurationServiceDefinition } from '@/compiled_proto/com/celertech/baseserver/communication/protobuf/ServerConigurationService';
import { ServerEventServiceDefinition } from '@/compiled_proto/com/celertech/baseserver/communication/protobuf/ServerEventService';
import { MarketDataServiceDefinition } from '@/compiled_proto/com/celertech/marketdata/api/notification/MarketDataServiceProto';
import { OrderServiceDefinition } from '@/compiled_proto/com/celertech/orderrouting/api/notification/OrderServiceProto';
import { PiggyBankServiceDefinition } from '@/compiled_proto/com/celertech/piggybank/api/PiggyBankServiceProto';
import { PositionManagerServiceDefinition } from '@/compiled_proto/com/celertech/positionmanager/api/pnl/PostionManagerServiceProto';
import { PreferenceServiceDefinition } from '@/compiled_proto/com/celertech/preference/api/profile/PreferenceProto';
import { AccountPropertyServiceDefinition } from '@/compiled_proto/com/celertech/staticdata/api/account/property/AccountPropertyProto';
import { UserAccountServiceDefinition } from '@/compiled_proto/com/celertech/staticdata/api/user/account/UserAccountProto';
import { UserLimitServiceDefinition } from '@/compiled_proto/com/celertech/staticdata/api/user/limit/UserLimitProto';
import { createChannel, createClientFactory, WebsocketTransport } from 'nice-grpc-web';
import { conflationMiddleware, heartbeatMiddleware } from './grpcHelper';

type Environment = 'local' | 'uat' | 'demo' | 'wl' | 'prod';

const spotLogo = window.config?.logo;
const traderLogo = window.config?.trader_logo;
const digitalLogo = window.config?.digital_logo;

const UAT_HOSTNAME = window.config.envhostname?.uat;
const TRADER_UAT_HOSTNAME = window.config.envhostname?.['trader-uat'];
const DIGITAL_UAT_HOSTNAME = window.config.envhostname?.['digital-uat'];
const PORTAL_UAT_HOSTNAME = window.config.envhostname?.['portal-uat'];
const DEMO_HOSTNAME = window.config.envhostname?.demo;
const DEMO_WL_MH_HOSTNAME = window.config.envhostname?.['demo-wl-mh'];
const DEMO_WL_ARIVAL_HOSTNAME = window.config.envhostname?.['demo-wl-arival'];
const DEMO_WL_PAYTECH_HOSTNAME = window.config.envhostname?.['demo-wl-paytech'];
const DEMO_WL_WOLFBTC_HOSTNAME = window.config.envhostname?.['demo-wl-wolfbtc'];
const DEMO_WL_GLOBALBLOCK_HOSTNAME = window.config.envhostname?.['demo-wl-globalblock'];
const TRADER_DEMO_HOSTNAME = window.config.envhostname?.['trader-demo'];
const DIGITAL_DEMO_HOSTNAME = window.config.envhostname?.['digital-demo'];
const PORTAL_DEMO_HOSTNAME = window.config.envhostname?.['portal-demo'];
const DEBUG_DEMO_HOSTNAME = 'debug-demo-xplorspot.gc.exchange';
const WL_HOSTNAME = window.config.envhostname?.wl;
const TRADER_WL_HOSTNAME = window.config.envhostname?.['trader-wl'];
const DIGITAL_WL_HOSTNAME = window.config.envhostname?.['digital-wl'];
const PROD_HOSTNAME = window.config.envhostname?.prod;
const PROD_WL_MH_HOSTNAME = window.config.envhostname?.['prod-wl-mh'];
const PROD_WL_ARIVAL_HOSTNAME = window.config.envhostname?.['prod-wl-arival'];
const PROD_WL_PAYTECH_HOSTNAME = window.config.envhostname?.['prod-wl-paytech'];
const PROD_WL_WOLFBTC_HOSTNAME = window.config.envhostname?.['prod-wl-wolfbtc'];
const PROD_WL_GLOBALBLOCK_HOSTNAME = window.config.envhostname?.['prod-wl-globalblock'];
const TRADER_PROD_HOSTNAME = window.config.envhostname?.['trader-prod'];
const DIGITAL_PROD_HOSTNAME = window.config.envhostname?.['digital-prod'];
const PORTAL_PROD_HOSTNAME = window.config.envhostname?.['portal-prod'];
const DEBUG_PROD_HOSTNAME = 'debug-xplorspot.gc.exchange';
const DEBUG_INSTANCE = window.config.instance;

export const customChartStyles = window.config.chartStyles || '/charting_library/styles/tradingview.css';

const restChannelUrl = window.config.integration.celertech.rest;
const wsChannelUrl = window.config.integration.celertech.websocket;
export const createCustomClient = createClientFactory().use(conflationMiddleware).use(heartbeatMiddleware).create;
export const grpcChannelWs = createChannel(wsChannelUrl, WebsocketTransport());
export const grpcChannelUnary = createChannel(restChannelUrl);

export const serverEventsClient = {
    ws: createCustomClient(ServerEventServiceDefinition, grpcChannelWs)
};

export const logoutServiceClient = {
    unary: createCustomClient(LogoutServiceDefinition, grpcChannelUnary)
};

export const accountPropertyServiceClient = {
    unary: createCustomClient(AccountPropertyServiceDefinition, grpcChannelUnary)
};

export const marketDataServiceClient = {
    unary: createCustomClient(MarketDataServiceDefinition, grpcChannelUnary),
    ws: createCustomClient(MarketDataServiceDefinition, grpcChannelWs)
};

export const orderServiceClient = {
    unary: createCustomClient(OrderServiceDefinition, grpcChannelUnary),
    ws: createCustomClient(OrderServiceDefinition, grpcChannelWs)
};

export const loginServiceClient = {
    unary: createCustomClient(LoginServiceDefinition, grpcChannelUnary)
};

export const resetPasswordClient = {
    unary: createCustomClient(ChangePasswordServiceProtoDefinition, grpcChannelUnary)
};

export const preferenceClient = {
    unary: createCustomClient(PreferenceServiceDefinition, grpcChannelUnary)
};

export const userLimitServiceClient = {
    unary: createCustomClient(UserLimitServiceDefinition, grpcChannelUnary)
};

export const userAccountServiceClient = {
    unary: createCustomClient(UserAccountServiceDefinition, grpcChannelUnary)
};

export const piggyBankServiceClient = {
    unary: createCustomClient(PiggyBankServiceDefinition, grpcChannelUnary),
    ws: createCustomClient(PiggyBankServiceDefinition, grpcChannelWs)
};

export const positionManagerClient = {
    ws: createCustomClient(PositionManagerServiceDefinition, grpcChannelWs)
};

export const serverConfigurationsClient = {
    unary: createCustomClient(ServerConfigurationServiceDefinition, grpcChannelUnary)
};

export const getEnvironment = (): Environment => {
    if (window && window.location) {
        switch (window.location.hostname) {
            case 'onechart':
                return 'local';
            case 'localhost':
                return 'local';
            case UAT_HOSTNAME:
                return 'uat';
            case TRADER_UAT_HOSTNAME:
                return 'uat';
            case DIGITAL_UAT_HOSTNAME:
                return 'uat';
            case DEMO_HOSTNAME:
                return 'demo';
            case TRADER_DEMO_HOSTNAME:
                return 'demo';
            case DIGITAL_DEMO_HOSTNAME:
                return 'demo';
            case DEBUG_DEMO_HOSTNAME:
                return 'demo';
            case DEMO_WL_MH_HOSTNAME:
                return 'demo';
            case DEMO_WL_ARIVAL_HOSTNAME:
                return 'demo';
            case DEMO_WL_PAYTECH_HOSTNAME:
                return 'demo';
            case DEMO_WL_WOLFBTC_HOSTNAME:
                return 'demo';
            case DEMO_WL_GLOBALBLOCK_HOSTNAME:
                return 'demo';
            case WL_HOSTNAME:
                return 'wl';
            case TRADER_WL_HOSTNAME:
                return 'wl';
            case DIGITAL_WL_HOSTNAME:
                return 'wl';
            case PROD_HOSTNAME:
                return 'prod';
            case TRADER_PROD_HOSTNAME:
                return 'prod';
            case DIGITAL_PROD_HOSTNAME:
                return 'prod';
            case DEBUG_PROD_HOSTNAME:
                return 'prod';
            case PROD_WL_MH_HOSTNAME:
                return 'prod';
            case PROD_WL_ARIVAL_HOSTNAME:
                return 'prod';
            case PROD_WL_PAYTECH_HOSTNAME:
                return 'prod';
            case PROD_WL_WOLFBTC_HOSTNAME:
                return 'prod';
            case PROD_WL_GLOBALBLOCK_HOSTNAME:
                return 'prod';
            default:
                return 'local';
        }
    }

    return 'local';
};

export const getPlatform = () => {
    if (window && window.location) {
        switch (window.location.hostname) {
            case TRADER_UAT_HOSTNAME:
                return 'trader';
            case DIGITAL_UAT_HOSTNAME:
                return 'digital';
            case TRADER_DEMO_HOSTNAME:
                return 'trader';
            case DIGITAL_DEMO_HOSTNAME:
                return 'digital';
            case DEMO_WL_MH_HOSTNAME:
                return 'mh-spot';
            case DEMO_WL_ARIVAL_HOSTNAME:
                return 'arival-spot';
            case DEMO_WL_PAYTECH_HOSTNAME:
                return 'paytech-spot';
            case DEMO_WL_WOLFBTC_HOSTNAME:
                return 'wolfbtc-spot';
            case DEMO_WL_GLOBALBLOCK_HOSTNAME:
                return 'globalblock-spot';
            case WL_HOSTNAME:
                return 'wl-spot';
            case TRADER_WL_HOSTNAME:
                return 'wl-trader';
            case DIGITAL_WL_HOSTNAME:
                return 'wl-digital';
            case DEBUG_DEMO_HOSTNAME:
                return 'debug';
            case TRADER_PROD_HOSTNAME:
                return 'trader';
            case DIGITAL_PROD_HOSTNAME:
                return 'digital';
            case DEBUG_PROD_HOSTNAME:
                return 'debug';
            case PROD_WL_MH_HOSTNAME:
                return 'mh-spot';
            case PROD_WL_ARIVAL_HOSTNAME:
                return 'arival-spot';
            case PROD_WL_PAYTECH_HOSTNAME:
                return 'paytech-spot';
            case PROD_WL_WOLFBTC_HOSTNAME:
                return 'wolfbtc-spot';
            case PROD_WL_GLOBALBLOCK_HOSTNAME:
                return 'globalblock-spot';
            default:
                return 'spot';
        }
    }

    return 'spot';
};

export const getPlatformLogo = () => {
    if (window && window.location) {
        switch (window.location.hostname) {
            case TRADER_UAT_HOSTNAME:
                return traderLogo;
            case DIGITAL_UAT_HOSTNAME:
                return digitalLogo;
            case TRADER_DEMO_HOSTNAME:
                return traderLogo;
            case DIGITAL_DEMO_HOSTNAME:
                return digitalLogo;
            case DEBUG_DEMO_HOSTNAME:
                return spotLogo;
            case DEMO_WL_MH_HOSTNAME:
                return spotLogo;
            case DEMO_WL_ARIVAL_HOSTNAME:
                return spotLogo;
            case DEMO_WL_PAYTECH_HOSTNAME:
                return spotLogo;
            case DEMO_WL_WOLFBTC_HOSTNAME:
                return spotLogo;
            case DEMO_WL_GLOBALBLOCK_HOSTNAME:
                return spotLogo;
            case TRADER_WL_HOSTNAME:
                return traderLogo;
            case DIGITAL_WL_HOSTNAME:
                return digitalLogo;
            case TRADER_PROD_HOSTNAME:
                return traderLogo;
            case DIGITAL_PROD_HOSTNAME:
                return digitalLogo;
            case DEBUG_PROD_HOSTNAME:
                return spotLogo;
            case PROD_WL_MH_HOSTNAME:
                return spotLogo;
            case PROD_WL_ARIVAL_HOSTNAME:
                return spotLogo;
            case PROD_WL_PAYTECH_HOSTNAME:
                return spotLogo;
            case PROD_WL_WOLFBTC_HOSTNAME:
                return spotLogo;
            case PROD_WL_GLOBALBLOCK_HOSTNAME:
                return spotLogo;
            default:
                return spotLogo;
        }
    }

    return spotLogo;
};

export const getProtocol = () => {
    switch (window.location.hostname) {
        case 'localhost':
            return 'http:';
        default:
            return 'https:';
    }
};

export const getPortalURL = () => {
    if (window && window.location) {
        switch (window.location.hostname) {
            case 'onechart':
                return PORTAL_DEMO_HOSTNAME;
            case 'localhost':
                return 'localhost:3001';
            case UAT_HOSTNAME:
                return PORTAL_UAT_HOSTNAME;
            case TRADER_UAT_HOSTNAME:
                return PORTAL_UAT_HOSTNAME;
            case DIGITAL_UAT_HOSTNAME:
                return PORTAL_UAT_HOSTNAME;
            case DEMO_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case TRADER_DEMO_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DIGITAL_DEMO_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DEBUG_DEMO_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DEMO_WL_MH_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DEMO_WL_ARIVAL_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DEMO_WL_PAYTECH_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DEMO_WL_WOLFBTC_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case DEMO_WL_GLOBALBLOCK_HOSTNAME:
                return PORTAL_DEMO_HOSTNAME;
            case WL_HOSTNAME:
                return '';
            case TRADER_WL_HOSTNAME:
                return '';
            case DIGITAL_WL_HOSTNAME:
                return '';
            case PROD_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case TRADER_PROD_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case DIGITAL_PROD_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case PROD_WL_MH_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case PROD_WL_ARIVAL_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case PROD_WL_PAYTECH_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case PROD_WL_WOLFBTC_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case PROD_WL_GLOBALBLOCK_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            case DEBUG_PROD_HOSTNAME:
                return PORTAL_PROD_HOSTNAME;
            default:
                return PORTAL_DEMO_HOSTNAME;
        }
    }

    return PORTAL_DEMO_HOSTNAME;
};

export const shouldUseNopBalance = ['local', 'uat', 'demo', 'prod'].includes(getEnvironment());
export const shouldUseNopPositions = window.config.modules.account_value.mode === 'nop';
export const shouldUseNopProfitLoss = window.config.modules.profit_loss.mode === 'nop';
export const isDebugInstance = DEBUG_INSTANCE === 'debug';
export const protocol = getProtocol();
export const portalURL = getPortalURL();
export const portalAPI = (url: string) => `${protocol}//${portalURL}${url}`;

export const logoTitle = process.env.REACT_APP_DOCUMENT_TITLE || '';
export const spotTitle = process.env.REACT_APP_DOCUMENT_SPOT_TITLE || '';
export const liteTitle = process.env.REACT_APP_DOCUMENT_LITE_TITLE || '';
export const traderTitle = process.env.REACT_APP_DOCUMENT_TRADER_TITLE || '';
export const digitalTitle = process.env.REACT_APP_DOCUMENT_DIGITAL_TITLE || '';
export const docPortalTitle = process.env.REACT_APP_DOCUMENT_PORTAL_TITLE || '';

export const xplorSpotTitle = process.env.REACT_APP_SPOT_TITLE || '';
export const xplorSpotLiteTitle = process.env.REACT_APP_LITE_TITLE || '';
export const xplorTraderTitle = process.env.REACT_APP_TRADER_TITLE || '';
export const updatingTitle = process.env.REACT_APP_DIGITAL_TITLE || '';
export const portalTitle = process.env.REACT_APP_PORTAL_TITLE || '';

export const isRoundedPlatform = getPlatform().includes('arival');
export const shouldBorderRadiusFull = getPlatform().includes('arival');
export const isArivalPlatform = getPlatform().includes('arival');
export const isPaytechPlatform = getPlatform().includes('paytech');
export const isWolfBTCPlatform = getPlatform().includes('wolfbtc');
export const isGlobalBlockPlatform = getPlatform().includes('globalblock');
export const moduleBorderBottom = { 'border-b border-b-brand-neutral-700': !isRoundedPlatform };

export const roundedFullClassname = {
    'rounded-full': isRoundedPlatform
};
export const roundedClassname = {
    'rounded-full': isRoundedPlatform,
    'rounded-md': !isRoundedPlatform
};
export const roundedTopClassname = {
    'rounded-t-lg': isRoundedPlatform
};
export const roundedLgClassname = {
    'rounded-lg': isRoundedPlatform
};

export const roundedDropdownClassname = {
    'rounded-lg': isRoundedPlatform,
    'rounded-md': !isRoundedPlatform
};
